/** Solo desarrollo (`npm start`): invitación sin `/api/beta-*` (CRA no sirve esas rutas). */

const DEV_SESSION_KEY = '__dv_dev_invitation_ok';

export function isLocalInvitationGateSkipped() {
  return (
    process.env.NODE_ENV === 'development' &&
    String(process.env.REACT_APP_LOCAL_SKIP_INVITATION_GATE || '').toLowerCase() === 'true'
  );
}

export function getDevInvitationPassword() {
  if (process.env.NODE_ENV !== 'development') return '';
  return String(process.env.REACT_APP_BETA_DEV_PASSWORD || '').trim();
}

export function isDevInvitationSessionActive() {
  if (process.env.NODE_ENV !== 'development') return false;
  try {
    return sessionStorage.getItem(DEV_SESSION_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function setDevInvitationSessionActive() {
  if (process.env.NODE_ENV !== 'development') return;
  try {
    sessionStorage.setItem(DEV_SESSION_KEY, '1');
  } catch (_) {}
}

export function tryDevInvitationLogin(password) {
  const expected = getDevInvitationPassword();
  if (!expected || String(password || '') !== expected) return false;
  setDevInvitationSessionActive();
  return true;
}
